import { render, staticRenderFns } from "./purchaseBoxs.vue?vue&type=template&id=816861dc&scoped=true"
import script from "./purchaseBoxs.vue?vue&type=script&lang=js"
export * from "./purchaseBoxs.vue?vue&type=script&lang=js"
import style0 from "./purchaseBoxs.vue?vue&type=style&index=0&id=816861dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816861dc",
  null
  
)

export default component.exports